import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PriceDetailsComponent } from './price-details.component';

const routes: Routes = [
  { path: '', component: PriceDetailsComponent, data: { title: 'Price Details' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PriceDetailsRoutingModule {}

@NgModule({
  imports: [
    PriceDetailsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [PriceDetailsComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PriceDetailsModule {}
